import React from 'react';
import { VIDEO_RECORDING_PROFILE_NAMES, } from './../../../data/globalsettings';
import PropTypes from 'prop-types';

import { strings, getCurrentLocale } from './../../../localization';
import Switch from './../../../components/common/Switch';
import ProgressOverlay from './../../../components/common/ProgressOverlay';

import { UPDATE_SETTINGS_TIMEOUT } from './GlobalSettings';

export default class Cameras extends React.PureComponent {

    static propTypes = {
        accountDetails: PropTypes.object,
        cameraCabinAvailabilityPending: PropTypes.bool.isRequired,
        cameraCabinAvailabilityEnabled: PropTypes.bool,
        cameraCabinAvailabilityErrorMessage: PropTypes.string,
        toggleCameraCabinAvailability: PropTypes.func.isRequired,
        timeoutCameraCabinAvailability: PropTypes.func.isRequired,

        cameraRoadAvailabilityPending: PropTypes.bool.isRequired,
        cameraRoadAvailabilityEnabled: PropTypes.bool,
        cameraRoadAvailabilityErrorMessage: PropTypes.string,
        toggleCameraRoadAvailability: PropTypes.func.isRequired,
        timeoutCameraRoadAvailability: PropTypes.func.isRequired,

        videoRecordingProfileConfigAvailable: PropTypes.bool,
        videoRecordingProfilePending: PropTypes.bool.isRequired,
        videoRecordingProfile: PropTypes.string,
        videoRecordingProfileSettingLocked: PropTypes.bool,
        videoRecordingProfileSettingLockedElement: PropTypes.element,
        videoRecordingProfileErrorMessage: PropTypes.string,
        applyVideoRecordingProfile: PropTypes.func.isRequired,
        timeoutVideoRecordingProfile: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        camerasExpandReference: PropTypes.string.isRequired,
        camerasExpandReferenceIsExpanded: PropTypes.bool.isRequired,
        videoRecordingProfileExpandReference: PropTypes.string.isRequired,
        videoRecordingProfileExpandReferenceIsExpanded: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        this.applyCameraCabinAvailabilityTimeoutId = undefined;
        this.applyCameraRoadAvailabilityTimeoutId = undefined;
        this.applyVideoRecordingProfileTimeoutId = undefined;
    }

    componentWillUnmount() {
        clearTimeout(this.applyCameraCabinAvailabilityTimeoutId);
        clearTimeout(this.applyCameraRoadAvailabilityTimeoutId);
        clearTimeout(this.applyVideoRecordingProfileTimeoutId);
    }

    handleVideoRecordingProfileChange = (event) => {
        clearTimeout(this.applyVideoRecordingProfileTimeoutId);

        this.applyVideoRecordingProfileTimeoutId = setTimeout(() => {this.props.timeoutVideoRecordingProfile(this.props.videoRecordingProfile)}, UPDATE_SETTINGS_TIMEOUT);
        this.props.applyVideoRecordingProfile(event.target.value, this.props.videoRecordingProfile)
        .then(
            () => {clearTimeout(this.applyVideoRecordingProfileTimeoutId)},
            () => {clearTimeout(this.applyVideoRecordingProfileTimeoutId)}
        )
    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.camerasExpandReference,
            this.props.videoRecordingProfileExpandReference
        ]);
    }

    render() {
        const cameraCabinAvailabilityEnabled = this.props.cameraCabinAvailabilityEnabled ? true : false; // sanitizing "undefined"s
        const cameraRoadAvailabilityEnabled = this.props.cameraRoadAvailabilityEnabled ? true : false; // sanitizing "undefined"s
        
        let strings_settings_global_video_recording_profile_standard_description = "";
        let strings_settings_global_video_recording_profile_balanced_description = "";
        let strings_settings_global_video_recording_profile_extended_description = "";

        let strings_video_recording_profile_recording_duration_legacy_internal_duration = "";
        let strings_video_recording_profile_recording_duration_legacy_64gb_duration = "";
        let strings_video_recording_profile_recording_duration_legacy_256gb_duration = "";
      
        let strings_video_recording_profile_recording_duration_standard_internal_duration = "";
        let strings_video_recording_profile_recording_duration_standard_64gb_duration = "";
        let strings_video_recording_profile_recording_duration_standard_256gb_duration = "";
      
        let strings_video_recording_profile_recording_duration_balanced_internal_duration = "";
        let strings_video_recording_profile_recording_duration_balanced_64gb_duration = "";
        let strings_video_recording_profile_recording_duration_balanced_256gb_duration = "";
      
        let strings_video_recording_profile_recording_duration_extended_internal_duration = "";
        let strings_video_recording_profile_recording_duration_extended_64gb_duration = "";
        let strings_video_recording_profile_recording_duration_extended_256gb_duration = "";
      
        if (this.props.accountDetails && this.props.accountDetails.accountType) {
            if (this.props.accountDetails.accountType === "FLEET") {
                strings_settings_global_video_recording_profile_standard_description = strings.settings_global_video_recording_profile_standard_description_fleet;
                strings_settings_global_video_recording_profile_balanced_description = strings.settings_global_video_recording_profile_balanced_description_fleet;
                strings_settings_global_video_recording_profile_extended_description = strings.settings_global_video_recording_profile_extended_description_fleet;
        
                strings_video_recording_profile_recording_duration_legacy_internal_duration = strings.video_recording_profile_recording_duration_legacy_internal_duration_fleet;
                strings_video_recording_profile_recording_duration_legacy_64gb_duration = strings.video_recording_profile_recording_duration_legacy_64gb_duration_fleet;
                strings_video_recording_profile_recording_duration_legacy_256gb_duration = strings.video_recording_profile_recording_duration_legacy_256gb_duration_fleet;
              
                strings_video_recording_profile_recording_duration_standard_internal_duration = strings.video_recording_profile_recording_duration_standard_internal_duration_fleet;
                strings_video_recording_profile_recording_duration_standard_64gb_duration = strings.video_recording_profile_recording_duration_standard_64gb_duration_fleet;
                strings_video_recording_profile_recording_duration_standard_256gb_duration = strings.video_recording_profile_recording_duration_standard_256gb_duration_fleet;
              
                strings_video_recording_profile_recording_duration_balanced_internal_duration = strings.video_recording_profile_recording_duration_balanced_internal_duration_fleet;
                strings_video_recording_profile_recording_duration_balanced_64gb_duration = strings.video_recording_profile_recording_duration_balanced_64gb_duration_fleet;
                strings_video_recording_profile_recording_duration_balanced_256gb_duration = strings.video_recording_profile_recording_duration_balanced_256gb_duration_fleet;
              
                strings_video_recording_profile_recording_duration_extended_internal_duration = strings.video_recording_profile_recording_duration_extended_internal_duration_fleet;
                strings_video_recording_profile_recording_duration_extended_64gb_duration = strings.video_recording_profile_recording_duration_extended_64gb_duration_fleet;
                strings_video_recording_profile_recording_duration_extended_256gb_duration = strings.video_recording_profile_recording_duration_extended_256gb_duration_fleet;
            } else {
                strings_settings_global_video_recording_profile_standard_description = strings.settings_global_video_recording_profile_standard_description_consumer;
                strings_settings_global_video_recording_profile_balanced_description = strings.settings_global_video_recording_profile_balanced_description_consumer;
                strings_settings_global_video_recording_profile_extended_description = strings.settings_global_video_recording_profile_extended_description_consumer;
        
                strings_video_recording_profile_recording_duration_legacy_internal_duration = strings.video_recording_profile_recording_duration_legacy_internal_duration_consumer;
                strings_video_recording_profile_recording_duration_legacy_64gb_duration = strings.video_recording_profile_recording_duration_legacy_64gb_duration_consumer;
                strings_video_recording_profile_recording_duration_legacy_256gb_duration = strings.video_recording_profile_recording_duration_legacy_256gb_duration_consumer;
              
                strings_video_recording_profile_recording_duration_standard_internal_duration = strings.video_recording_profile_recording_duration_standard_internal_duration_consumer;
                strings_video_recording_profile_recording_duration_standard_64gb_duration = strings.video_recording_profile_recording_duration_standard_64gb_duration_consumer;
                strings_video_recording_profile_recording_duration_standard_256gb_duration = strings.video_recording_profile_recording_duration_standard_256gb_duration_consumer;
              
                strings_video_recording_profile_recording_duration_balanced_internal_duration = strings.video_recording_profile_recording_duration_balanced_internal_duration_consumer;
                strings_video_recording_profile_recording_duration_balanced_64gb_duration = strings.video_recording_profile_recording_duration_balanced_64gb_duration_consumer;
                strings_video_recording_profile_recording_duration_balanced_256gb_duration = strings.video_recording_profile_recording_duration_balanced_256gb_duration_consumer;
              
                strings_video_recording_profile_recording_duration_extended_internal_duration = strings.video_recording_profile_recording_duration_extended_internal_duration_consumer;
                strings_video_recording_profile_recording_duration_extended_64gb_duration = strings.video_recording_profile_recording_duration_extended_64gb_duration_consumer;
                strings_video_recording_profile_recording_duration_extended_256gb_duration = strings.video_recording_profile_recording_duration_extended_256gb_duration_consumer;
            }
        }

        return (
            <div id="component_document_id_cameras">
                <h3>
                    <button
                        className={this.props.streamingVideoAudioExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                        onClick={() => {
                            this.expandOrCollapseSectionsAndSubsections(!this.props.camerasExpandReferenceIsExpanded)}
                        }>
                        {strings.settings_global_cameras_header}
                        <i className="material-icons disclosure">keyboard_arrow_up</i>
                    </button>
                </h3>
                <div>{strings.settings_global_cameras_description}</div>
                <div className='setting-group-horiz'>
                    <div className='setting-group switch-group'>
                        <div>
                            <Switch
                                onChange={() => {

                                    clearTimeout(this.applyCameraCabinAvailabilityTimeoutId);
                                    this.applyCameraCabinAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutCameraCabinAvailability(cameraCabinAvailabilityEnabled)}, UPDATE_SETTINGS_TIMEOUT);

                                    this.props.toggleCameraCabinAvailability()
                                    .then(
                                        () => {clearTimeout(this.applyCameraCabinAvailabilityTimeoutId)},
                                        () => {clearTimeout(this.applyCameraCabinAvailabilityTimeoutId)}
                                    )
                                }}
                                checked={cameraCabinAvailabilityEnabled}
                                disabled={this.props.cameraCabinAvailabilityPending}
                                smallFormat={true}
                            />
                            <label disabled={this.props.cameraCabinAvailabilityPending}>{this.props.cameraCabinAvailabilityEnabled?
                                strings.settings_global_cameras_cabin_are_enabled
                            :
                                strings.settings_global_cameras_cabin_are_disabled
                            }</label>
                            {this.props.cameraCabinAvailabilityPending ? <ProgressOverlay /> : null }
                        </div>
                        <div className="error-message">
                            {this.props.cameraCabinAvailabilityErrorMessage}
                        </div>
                        <div>
                            <Switch
                                onChange={() => {

                                    clearTimeout(this.applyCameraRoadAvailabilityTimeoutId);
                                    this.applyCameraRoadAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutCameraRoadAvailability(cameraRoadAvailabilityEnabled)}, UPDATE_SETTINGS_TIMEOUT);

                                    this.props.toggleCameraRoadAvailability()
                                    .then(
                                        () => {clearTimeout(this.applyCameraRoadAvailabilityTimeoutId)},
                                        () => {clearTimeout(this.applyCameraRoadAvailabilityTimeoutId)}
                                    )
                                }}
                                checked={cameraRoadAvailabilityEnabled}
                                disabled={this.props.cameraRoadAvailabilityPending}
                                smallFormat={true}
                            />
                            <label disabled={this.props.cameraRoadAvailabilityPending}>{this.props.cameraRoadAvailabilityEnabled?
                                strings.settings_global_cameras_road_are_enabled
                            :
                                strings.settings_global_cameras_road_are_disabled
                            }</label>
                            {this.props.cameraRoadAvailabilityPending ? <ProgressOverlay /> : null }
                        </div>
                        <div className="error-message">
                            {this.props.cameraRoadAvailabilityErrorMessage}
                        </div>
                    </div>
                    {this.props.videoRecordingProfileConfigAvailable ?
                    <div className={this.props.videoRecordingProfileExpandReferenceIsExpanded ? "subgroup" : "subgroup collapsed"}>
                        <h5 className="subgroup-header">
                            <button disabled={true} // SUBSECTION_COLLAPSING_DISABLED
                                className={this.props.videoRecordingProfileExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                                onClick={() => {
                                    this.props.expandOrCollapseStateForUIReferences(
                                        !this.props.videoRecordingProfileExpandReferenceIsExpanded,
                                        [this.props.videoRecordingProfileExpandReference])
                                }}>
                                {strings.settings_global_video_recording_profile_header}
                                <i className="material-icons disclosure">keyboard_arrow_up</i>
                            </button>
                        </h5>
                        <div className="description">
                            {strings.settings_global_video_recording_profile_description}
                        </div>
                        {this.props.videoRecordingProfileSettingLockedElement}
                        <div className="error-message">
                            {this.props.videoRecordingProfileErrorMessage}
                        </div>
                        <div className='setting-group radio-group video-quality'>
                            <div>
                                <input type="radio" name="video-recording-profile" id={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.STANDARD}
                                    value={VIDEO_RECORDING_PROFILE_NAMES.STANDARD}
                                    checked={this.props.videoRecordingProfile === VIDEO_RECORDING_PROFILE_NAMES.STANDARD}
                                    onChange={this.handleVideoRecordingProfileChange}
                                    disabled={this.props.videoRecordingProfilePending}
                                />
                                <label htmlFor={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.STANDARD} disabled={this.props.videoRecordingProfilePending}>{strings.settings_global_video_recording_profile_standard_label}</label>
                                <ul className="aside-table-row">
                                    <li>{strings_video_recording_profile_recording_duration_standard_internal_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_standard_64gb_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_standard_256gb_duration}</li>
                                    <ul className={"aside-table-row header " + "language-subtag-" + getCurrentLocale()}>
                                        <li>{strings.video_recording_profile_recording_duration_internal_header}</li>
                                        <li>{strings.video_recording_profile_recording_duration_64gb_header}</li>
                                        <li>{strings.video_recording_profile_recording_duration_256gb_header}</li>
                                    </ul>
                                </ul>
                            </div>

                            <div>
                                <input type="radio" name="video-recording-profile" id={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.BALANCED}
                                    value={VIDEO_RECORDING_PROFILE_NAMES.BALANCED}
                                    checked={this.props.videoRecordingProfile === VIDEO_RECORDING_PROFILE_NAMES.BALANCED}
                                    onChange={this.handleVideoRecordingProfileChange}
                                    disabled={this.props.videoRecordingProfilePending}
                                />
                                <label htmlFor={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.BALANCED} disabled={this.props.videoRecordingProfilePending}>{strings.settings_global_video_recording_profile_balanced_label}</label>
                                <ul className="aside-table-row">
                                    <li>{strings_video_recording_profile_recording_duration_balanced_internal_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_balanced_64gb_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_balanced_256gb_duration}</li>
                                </ul>
                            </div>

                            <div>
                                <input type="radio" name="video-recording-profile" id={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.EXTENDED}
                                    value={VIDEO_RECORDING_PROFILE_NAMES.EXTENDED}
                                    checked={this.props.videoRecordingProfile === VIDEO_RECORDING_PROFILE_NAMES.EXTENDED}
                                    onChange={this.handleVideoRecordingProfileChange}
                                    disabled={this.props.videoRecordingProfilePending}
                                />
                                <label htmlFor={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.EXTENDED} disabled={this.props.videoRecordingProfilePending}>{strings.settings_global_video_recording_profile_extended_label}</label>
                                <ul className="aside-table-row">
                                    <li>{strings_video_recording_profile_recording_duration_extended_internal_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_extended_64gb_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_extended_256gb_duration}</li>
                                </ul>
                            </div>

                            <div className="related subgroup description">
                                {strings.settings_global_video_recording_profile_for_older_devices}
                            </div>
                            <div className="subgroup legacy">
                                <input type="radio" name="video-recording-profile" id={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.LEGACY}
                                    value={VIDEO_RECORDING_PROFILE_NAMES.LEGACY}
                                    checked={this.props.videoRecordingProfile === VIDEO_RECORDING_PROFILE_NAMES.LEGACY}
                                    onChange={this.handleVideoRecordingProfileChange}
                                    disabled={this.props.videoRecordingProfilePending}
                                />
                                <label htmlFor={"video-recording-profile:" + VIDEO_RECORDING_PROFILE_NAMES.LEGACY} disabled={this.props.videoRecordingProfilePending}>{strings.settings_global_video_recording_profile_legacy_label}</label>
                                <ul className="aside-table-row">
                                    <li>{strings_video_recording_profile_recording_duration_legacy_internal_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_legacy_64gb_duration}</li>
                                    <li>{strings_video_recording_profile_recording_duration_legacy_256gb_duration}</li>
                                    <ul className={"aside-table-row header " + "language-subtag-" + getCurrentLocale()}>
                                        <li>{strings.video_recording_profile_recording_duration_internal_header}</li>
                                        <li>{strings.video_recording_profile_recording_duration_64gb_header}</li>
                                        <li>{strings.video_recording_profile_recording_duration_256gb_header}</li>
                                    </ul>
                                </ul>
                            </div>
                            {this.props.videoRecordingProfileSettingLocked ? <div className='disabled-overlay'></div> : null }
                            {this.props.videoRecordingProfilePending ? <ProgressOverlay /> : null }
                        </div>
                    </div>
                    :
                        null
                    }
                </div>
            </div>
        );
    }
}